import React from "react";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { getTimeAgo } from "_helpers";
import { removeIdTag } from "components/v3/views/Analyze/Utilities/analyzeUtils";

export default function MessageListItem({ data }) {
  const author = removeIdTag(data.author);
  const datetime = getTimeAgo(data.messageDate);
  const snippet = data.messageText;

  return (
    <Link to={`/inbox-v2/${data.messageId}`} className="tms-no-underline">
      <Box sx={styles.wrapper}>
        <Box>
          <Box as="p" sx={styles.authorName}>
            {author}
          </Box>

          <Box as="p" sx={styles.snippet}>
            {snippet}
          </Box>
        </Box>

        <Box component={"p"} sx={styles.datetime}>
          {datetime}
        </Box>
      </Box>
    </Link>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "16px 20px 16px",
    borderBottom: "1px solid #f0ece5",
  },
  authorName: {
    color: "#1a2b20",
    m: 0,
    fontFamily: "FustatSemiBold",
    fontSize: "16px",
    pb: "4px",
  },
  username: {
    color: "#98a29a",
    m: 0,
    fontFamily: "FustatMedium",
    fontSize: "12px",
  },
  snippet: {
    color: "#55605a",
    m: 0,
    fontFamily: "FustatRegular",
    fontSize: "14px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "1",
    WebkitBoxOrient: "vertical",
  },
  datetime: {
    color: "#98a29a",
    fontFamily: "FustatMedium",
    fontSize: "12px",
    m: 0,
    minWidth: "max-content",
  },
};
